export const trackerStatuses = {
  CAMPAIGN_CREATED: 'Campaign Created',
  PENDING_ART_BRIEF: 'Payment Method Added',
  PENDING_PAYMENT_METHOD: 'Art Brief Submitted',
  PENDING_ART_PROOF: 'Pending Art Proof',
  PENDING_ART_PROOF_APPROVAL: 'Art Proof Provided',
  ART_PROOF_REJECTED: 'Art Proof Rejected',
  ART_PROOF_APPROVED: 'Art Proof Sign Off',
  LOCATION_REJECTED: 'Art Not Installed',
  PRODUCTION_IN_PROGRESS: 'Billboard Production In Progress',
  SCHEDULED_FOR_INSTALL: 'Scheduled for Billboard Installation',
  OUT_FOR_INSTALL: 'Out for Installation',
  BILLBOARD_INSTALLED: 'Billboard Installed',
};

export const campaignStatuses = {
  DRAFT: '0',
  CAMPAIGN_CREATED: '1',
  PENDING_ART_BRIEF: '2',
  PENDING_PAYMENT_METHOD: '3',
  PENDING_ART_PROOF: '4',
  PENDING_ART_PROOF_APPROVAL: '5',
  ART_PROOF_REJECTED: '6',
  ART_PROOF_APPROVED: '7',
  LOCATION_REJECTED: '8',
  PRODUCTION_IN_PROGRESS: '9',
  SCHEDULED_FOR_INSTALL: '10',
  OUT_FOR_INSTALL: '11',
  BILLBOARD_INSTALLED: '12',
  CANCELLED: '14',
  RELEASED: '15',
  COMPLETE: '16',
  COLLECTIONS: '18',
};

export const withoutDraftStatuses = Object.values(campaignStatuses)
  .filter((el) => el !== campaignStatuses.DRAFT)
  .join(',');

export const labeledTrackerStatuses = {
  [campaignStatuses.CAMPAIGN_CREATED]: trackerStatuses.CAMPAIGN_CREATED,
  [campaignStatuses.PENDING_ART_BRIEF]: trackerStatuses.PENDING_ART_BRIEF,
  [campaignStatuses.PENDING_PAYMENT_METHOD]:
    trackerStatuses.PENDING_PAYMENT_METHOD,
  [campaignStatuses.PENDING_ART_PROOF]: trackerStatuses.PENDING_ART_PROOF,
  [campaignStatuses.PENDING_ART_PROOF_APPROVAL]:
    trackerStatuses.PENDING_ART_PROOF_APPROVAL,
  [campaignStatuses.ART_PROOF_REJECTED]: trackerStatuses.ART_PROOF_REJECTED,
  [campaignStatuses.ART_PROOF_APPROVED]: trackerStatuses.ART_PROOF_APPROVED,
  [campaignStatuses.LOCATION_REJECTED]: trackerStatuses.LOCATION_REJECTED,
  [campaignStatuses.PRODUCTION_IN_PROGRESS]:
    trackerStatuses.PRODUCTION_IN_PROGRESS,
  [campaignStatuses.SCHEDULED_FOR_INSTALL]:
    trackerStatuses.SCHEDULED_FOR_INSTALL,
  [campaignStatuses.OUT_FOR_INSTALL]: trackerStatuses.OUT_FOR_INSTALL,
  [campaignStatuses.BILLBOARD_INSTALLED]: trackerStatuses.BILLBOARD_INSTALLED,
};

export const campaignPaymentStatuses = {
  NOT_SUBMITTED: 1,
  SUBMITTED: 2,
  SIGNATURE_REQUIRED: 3,
};

export const campaignArtStatuses = {
  NOT_SUBMITTED: 1,
  ART_REQUIRED: 2,
  ART_REVIEW: 3,
  ART_REJECTED: 4,
  ART_ACCEPTED: 5,
  ART_LOCATION_SIGNED: 6,
  ART_LOCATION_REJECTED: 7,
};

export const designArtStatuses = {
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

export const billingStatuses = {
  SCHEDULED: 'scheduled',
  BILLED: 'billed',
  INVOICE: 'invoice',
  PAID: 'paid',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
};

export const billingStatusesLabels = {
  [billingStatuses.SCHEDULED]: 'Scheduled',
  [billingStatuses.BILLED]: 'Billed',
  [billingStatuses.INVOICE]: 'Invoice',
  [billingStatuses.PAID]: 'Paid',
  [billingStatuses.FAILED]: 'Failed',
  [billingStatuses.CANCELLED]: 'Cancelled',
};

export const billingStatusesItems = {
  [billingStatuses.SCHEDULED]: {
    title: billingStatusesLabels[billingStatuses.SCHEDULED],
    value: billingStatuses.SCHEDULED,
    color: 'grey',
  },
  [billingStatuses.BILLED]: {
    title: billingStatusesLabels[billingStatuses.BILLED],
    value: billingStatuses.BILLED,
    color: 'success',
  },
  [billingStatuses.INVOICE]: {
    title: billingStatusesLabels[billingStatuses.INVOICE],
    value: billingStatuses.INVOICE,
    color: 'grey',
  },
  [billingStatuses.PAID]: {
    title: billingStatusesLabels[billingStatuses.PAID],
    value: billingStatuses.PAID,
    color: 'success',
  },
  [billingStatuses.FAILED]: {
    title: billingStatusesLabels[billingStatuses.FAILED],
    value: billingStatuses.FAILED,
    color: 'error',
  },
  [billingStatuses.CANCELLED]: {
    title: billingStatusesLabels[billingStatuses.CANCELLED],
    value: billingStatuses.CANCELLED,
    color: 'error',
  },
};
